import LabRepository from "./LabRepository";

const resource = "/test-package-sample";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },

  get(id, params) {
    return LabRepository.get(`${resource}/${id}`, { params });
  },

  create(payload) {
    return LabRepository.post(resource, payload);
  },

  update(id, payload) {
    return LabRepository.put(`${resource}/${id}`, payload);
  },

  suspend(id) {
    return LabRepository.delete(`${resource}/${id}`);
  },

  getPackageGroup(id) {
    return LabRepository.get(`${resource}/${id}/test-package-group`);
  },
};
